import script from "./lookBack.vue?vue&type=script&lang=ts&setup=true"
export * from "./lookBack.vue?vue&type=script&lang=ts&setup=true"

import "./lookBack.vue?vue&type=style&index=0&id=7a00bdc4&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a00bdc4"]])

export default __exports__